<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="bg-light border-bottom-0 modal-header">
                <h5 class="modal-title">{{$t("Secondary Email")}}</h5>
                <button type="button" class="close" data-dismiss="modal" @click="resetvalue">&times;</button>
            </div>
            <div class="modal-body">
                <section id="ModalAddSecondaryEmail">
                    <form v-if="!alreadysecondaryemail">
                        <fieldset>
                            <div class="row" v-if="message">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="alert alert-danger">
                                            <i class="fa fa-info-circle"></i> {{ $t(message) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group" v-bind:class="{'form-group-error': $v.form.secondaryemail.$error}">
                                        <label>{{$t("Secondary Email")}}</label>
                                        <input type="text" :placeholder="$t('Enter Secondary Email')" class="form-control" v-model.trim.lazy="$v.form.secondaryemail.$model" />
                                        <div v-if="!$v.form.secondaryemail.required" class="validation-invalid-label">{{$t('Please enter secondary email.')}}</div>
                                        <div v-else-if="!$v.form.secondaryemail.email" class="validation-invalid-label">{{$t('Email invalid')}}</div>
                                        <div v-else-if="!$v.form.secondaryemail.checkcurrentemail" class="validation-invalid-label">{{$t('The current email cannot be used as a secondary email.')}}</div>
                                        <div v-else-if="!$v.form.secondaryemail.checkemail" class="validation-invalid-label">{{$t(messageEmail)}}</div>
                                        <div
                                          v-if="$v.form.secondaryemail.checkcurrentemail && !$v.form.secondaryemail.checkemail && subStatus && subStatusMessage"
                                          style="color: #999999;font-size: 12px"
                                          class="validation-invalid-email"
                                        >
                                          {{ $t('_Email.Response Message') + ': ' + $t(subStatusMessage) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group" v-bind:class="{'form-group-error': $v.form.currentpassword.$error}">
                                        <label>{{$t("Current password")}}</label>
                                        <div class="input-group input-group-lg">
                                            <input :type="currentpasswordFieldType" :placeholder="$t('Current password')" style="font-family: arial" class="form-control" v-model.trim.lazy="$v.form.currentpassword.$model" />
                                            <span class="input-group-append" @click="confirmswitchVisibiliry">
                                                <button type="button" class="btn btn-light btn-icon" tabindex="-1"><i :class="iconcurrentpassword"></i></button>
                                            </span>
                                        </div>
                                        <div v-if="!$v.form.currentpassword.required" class="validation-invalid-label">{{$t('Please enter current password.')}}</div>
                                        <div v-else-if="!$v.form.currentpassword.minLength" class="validation-invalid-label">{{$t('Current password must have at least') + ' ' + $v.form.currentpassword.$params.minLength.min + ' ' + $t('digits.')}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group mt-3 mb-0">
                                <div class="text-center">
                                    <ladda text="Save" :loading="loading" :btnClass="'btn btn-primary'" :disabled="$v.validationGroup.$invalid" @click="goSecondaryEmail()"></ladda>
                                    <ladda text="Cancel" :btnClass="'btn btn-light ml-2'" @click="resetvalue" data-dismiss="modal"></ladda>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                    <form v-else>
                        <fieldset>
                            <div class="form-group" >
                                <div class="text-center mb-3">
                                    <img alt="" :src="$storeIndex.getImageGobalAssets('authorization/logo go_ship_02')">
                                </div>
                                <div class="text-center mb-3">
                                    <h3>{{$t('Confirm Secondary Email Complete')}}</h3>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </section>
            </div>
        </div>
    </div>
</template>

<style scoped>
    div.validation-invalid-label { display: none !important; }
    div.form-group-error>div.validation-invalid-label { display: block !important; }
    div.validation-invalid-email { display: none !important; }
    div.form-group-error>div.validation-invalid-email { display: block !important; }
</style>

<script>
import CentralApi from '@/services/endpoint/central.service';
import { required, minLength, email} from "vuelidate/lib/validators";
import Ladda from '@/plugins/Ladda.vue';
export default {
    props:['userid', 'currentemail'],
    components: {
        Ladda
    },
    data() {
        return {
            user_id:'',
            user_email:'',
            alreadysecondaryemail: false,
            loading: false,
            message: '',
            messageEmail:'',
            currentpasswordFieldType: 'password',
            iconcurrentpassword: 'far fa-eye-slash',
            form: {
                secondaryemail:'',
                currentpassword: '',
            },
            subStatus: false,
            subStatusMessage: '',
        };
    },
    validationConfig: {
        $lazy: true,
    },
    validations: {
        form: {
            secondaryemail: {
                required,
                email,
                async checkcurrentemail(emailAddress) {
                    if (this.currentemail === emailAddress) {
                        return false;
                    } else {
                        return true;
                    }
                },
                async checkemail(emailAddress) {

                  if(!emailAddress) return;
                  
                  const res = await CentralApi.Auth.isEmailValid(emailAddress);
                  let data = res.data;
                  if (data.valid !== true) {
                    this.messageEmail = data.message;
                  }
                  if (data.valid !== true && (data.sub_status != undefined && data.sub_status != '')) {
                      let errorMessage = this.emailInvalidMessage(data.sub_status);
                      if (errorMessage != '') {
                        this.subStatus = true;
                        this.subStatusMessage = errorMessage;
                      }
                  } else {
                      this.subStatus = false;
                      this.subStatusMessage = '';
                  }
                  return data.valid;
                }
            },
            currentpassword: {
                required,
                minLength: minLength(8)
            },
        },
        validationGroup: ['form.secondaryemail', 'form.currentpassword']
    },
    methods: {
        async confirmswitchVisibiliry() {
            this.currentpasswordFieldType = this.currentpasswordFieldType === 'password'? 'text': 'password';
            this.iconcurrentpassword = this.iconcurrentpassword === 'far fa-eye-slash'? 'far fa-eye': 'far fa-eye-slash';
        },
        emailInvalidMessage(status) {
          let message = '';
            switch (status) {
              case 'antispam_system':
                message = 'The email is protected by an anti-spam system. This prevents us from verifying its authenticity. Please contact the admin.';
                break;
              case 'does_not_accept_mail':
                message = 'This domain allows sending email only. Unable to receive email. Please use another email.';
                break;
              case 'exception_occurred':
                message = 'We encountered an exception while validating this email. Please ensure the email is correct and try again.';
                break;
              case 'failed_smtp_connection':
                message = "This email belongs to a mail server that won't allow an SMTP connection. Please use another email.";
                break;
              case 'failed_syntax_check':
                message = 'This email failed to use the RFC syntax protocol. Please use another email.';
                break;
              case 'forcible_disconnect':
                message = 'This email belongs to a mail server that disconnects immediately when a connection is established. Please use another email.';
                break;
              case 'global_suppression':
                message = 'This email was found on many popular global suppression lists (GSLs). Please use another email.';
                break;
              case 'greylisted':
                message = 'This email is temporarily unable to be validated. Please try again.';
                break;
              case 'mail_server_did_not_respond':
                message = 'This mail server is not responding to mail commands. Please use another email.';
                break;
              case 'mail_server_temporary_error':
                message = 'This mail server returned a temporary error. Please try again.';
                break;
              case 'mailbox_quota_exceeded':
                message = 'This email exceeds the mailbox quota and unable to receiv email. Please clear your mailbox space.';
                break;
              case 'mailbox_not_found':
                message = 'This email does not exist. Please use another email.';
                break;
              case 'no_dns_entries':
                message = 'The domain is not recorded in DNS or is recorded but incomplete. Makes it impossible to send email. Please use another email.';
                break;
              case 'possible_trap':
                message = 'This email contains keywords that could be related to possible spam traps, such as spam@ or @spam.com. Please use another email.';
                break;
              case 'possible_typo':
                message = 'Misspelled domains. Please ensure the email is correct and try again.';
                break;
              case 'role_based':
                message = 'This email belongs to role-based emails that are often reported as spam and abuse. Please use another email.';
                break;
              case 'role_based_catch_all':
                message = 'This email is role-based and also belongs to the catch_all domain. Please use another email.';
                break;
              case 'timeout_exceeded':
                message = 'This email belongs to a mail server that is responding extremely slowly. Please use another email.';
                break;
              case 'unroutable_ip_address':
                message = 'This email domain points to an un-routable IP address. Please use another email.';
                break;
              case 'disposable':
                message = 'This email is temporary and has a short lifespan ranging from 15 minutes to approximately 6 months. Please use another email.';
                break;
              case 'toxic':
                message = 'This email is abused, spam, or bot-created emails. Please use another email.';
                break;
              default:
                break;
            }
            return message;
        },
        async resetvalue() {
            this.$v.$reset();
            const initialData = this.$options.data.call(this);
            Object.assign(this.$data, initialData);
        },
        async goSecondaryEmail() {
            console.log(this.userid);
            this.loading = true;
            let params = {
                secondary_email: this.$v.form.secondaryemail.$model,
                current_password: this.$v.form.currentpassword.$model
            }
            await CentralApi.User.addSecondaryEmail(this.userid, params).then((res) =>{

                this.$toastr.s(this.$t("Save Secondary Email Complete"),"<span class='t-icon icon-checkmark3'></span>"+this.$t("Success"));
                this.alreadysecondaryemail = true;
                $('#ModalAddSecondaryEmail').modal('hide');

                this.$parent.SecondaryEmailStatus = false;
                this.$parent.getUser();
                this.$nextTick(() => {
                    this.$parent.SecondaryEmailStatus = true;
                });

            },
            error => {
                this.message = error.response.data.message;
                this.loading = false;
            });
        }
    },
    mounted() {
    }
}
</script>



// WEBPACK FOOTER //
// src/components/central/account/security/ModalAddSecondaryEmail.vue